<template>
  <div class="esp-container">
    <Modal v-model:modelValue="showModalHelp" title="Ayuda — Odontograma">
      <AyudaOdontologia />
    </Modal>

    <!-- Toolbar -->
    <div class="card mb-3">
      <div class="card-body py-2">
<!-- Toggle Editar / Consultar como tabs -->
<div class="d-flex align-items-center gap-3 mb-2 border-bottom pb-2">
  <button
    type="button"
    class="tab-modo"
    :class="modoVista === 'editar' ? 'tab-modo-active-edit' : 'tab-modo-inactive'"
    :disabled="!editable"
    @click="modoVista = 'editar'">
    <span class="material-symbols-outlined" style="font-size:16px;vertical-align:middle">edit</span>
    Modo Edición
  </button>
  <button
    type="button"
    class="tab-modo"
    :class="modoVista === 'consultar' ? 'tab-modo-active-view' : 'tab-modo-inactive'"
    @click="modoVista = 'consultar'">
    <span class="material-symbols-outlined" style="font-size:16px;vertical-align:middle">pageview</span>
    Modo Consulta
  </button>
  <!-- Indicador de modo activo -->
  <span v-if="modoVista === 'editar'" class="badge bg-warning text-dark ms-1" style="font-size:11px">
    <span class="material-symbols-outlined" style="font-size:12px;vertical-align:middle">brush</span>
    Selecciona un estado y haz clic en el diente
  </span>
  <span v-else class="badge bg-info text-dark ms-1" style="font-size:11px">
    <span class="material-symbols-outlined" style="font-size:12px;vertical-align:middle">touch_app</span>
    Clic en un diente para ver su detalle
  </span>
</div>

        <!-- Modos de pintura — solo en modo editar -->
        <div class="d-flex flex-wrap gap-2 align-items-center">
          <template v-if="modoVista === 'editar'">
            <span class="fw-bold me-1" style="font-size:12px">Estado:</span>
            <button
              v-for="modo in modos"
              :key="modo.valor"
              type="button"
              class="btn btn-sm"
              :class="modoActual === modo.valor ? 'btn-primary' : 'btn-outline-secondary'"
              :disabled="!editable"
              @click="modoActual = modo.valor">
              <span :style="{ color: modoActual === modo.valor ? '#fff' : modo.color }">
                {{ modo.etiqueta }}
              </span>
            </button>
          </template>

          <!-- Modo consultar — indicador -->
          <template v-else>
            <span class="badge bg-info text-dark">
              <span class="material-symbols-outlined" style="font-size:13px;vertical-align:middle">info</span>
              Clic en un diente para ver su detalle
            </span>
          </template>

          <!-- Acciones -->
          <div class="ms-auto d-flex gap-2">
            <button type="button" class="btn btn-sm btn-outline-danger"
              :disabled="!editable || modoVista === 'consultar'"
              @click="limpiarOdontograma">
              <span class="material-symbols-outlined" style="font-size:16px">restart_alt</span>
              Limpiar
            </button>
            <button type="button" class="btn btn-sm btn-success"
              :disabled="!editable || guardando || modoVista === 'consultar'"
              @click="guardarOdontograma">
              <span class="material-symbols-outlined" style="font-size:16px">save</span>
              {{ guardando ? 'Guardando...' : 'Guardar' }}
            </button>
      <button
        class="btn-help"
        type="button"
        title="Abrir ayuda"
        @click="showModalHelp = true"
        aria-label="Abrir ayuda del odontograma"
      >
        <span class="material-symbols-outlined">help</span>
      </button>
          </div>

        </div>
      </div>
    </div>

    <!-- Odontograma -->
    <div class="card mb-3">
      <div class="card-body">

        <div class="text-center mb-1">
          <small class="text-muted fw-bold">SUPERIOR</small>
        </div>
        <div class="d-flex justify-content-center flex-wrap gap-1 mb-2">
          <div v-for="num in dientesSuperiores" :key="num"
            class="diente-wrap text-center"
            :class="{ 'diente-consulta': modoVista === 'consultar', 'diente-seleccionado': piezaSeleccionada === num }"
            @click="aplicarModo(num)"
            :title="modoVista === 'consultar' ? `Ver pieza ${num}` : `Asignar ${modoActual} a pieza ${num}`">
            <small class="d-block" style="font-size:9px; color:#888">{{ num }}</small>
            <svg width="30" height="30" viewBox="0 0 30 30">
              <rect x="2" y="2" width="26" height="26" rx="4"
                :fill="colorPieza(num)"
                :stroke="piezaSeleccionada === num ? '#333' : '#ccc'"
                :stroke-width="piezaSeleccionada === num ? '2.5' : '1'"/>
              <text x="15" y="20" text-anchor="middle" font-size="13" font-weight="500" fill="#fff">
                {{ simboloPieza(num) }}
              </text>
            </svg>
          </div>
        </div>

        <hr class="my-1">

        <div class="d-flex justify-content-center flex-wrap gap-1 mt-2">
          <div v-for="num in dientesInferiores" :key="num"
            class="diente-wrap text-center"
            :class="{ 'diente-consulta': modoVista === 'consultar', 'diente-seleccionado': piezaSeleccionada === num }"
            @click="aplicarModo(num)"
            :title="modoVista === 'consultar' ? `Ver pieza ${num}` : `Asignar ${modoActual} a pieza ${num}`">
            <svg width="30" height="30" viewBox="0 0 30 30">
              <rect x="2" y="2" width="26" height="26" rx="4"
                :fill="colorPieza(num)"
                :stroke="piezaSeleccionada === num ? '#333' : '#ccc'"
                :stroke-width="piezaSeleccionada === num ? '2.5' : '1'"/>
              <text x="15" y="20" text-anchor="middle" font-size="13" font-weight="500" fill="#fff">
                {{ simboloPieza(num) }}
              </text>
            </svg>
            <small class="d-block" style="font-size:9px; color:#888">{{ num }}</small>
          </div>
        </div>

        <div class="text-center mt-1">
          <small class="text-muted fw-bold">INFERIOR</small>
        </div>

        <!-- Leyenda -->
        <div class="d-flex flex-wrap gap-3 mt-3 justify-content-center">
          <div v-for="modo in modos" :key="modo.valor" class="d-flex align-items-center gap-1">
            <div class="rounded" style="width:14px;height:14px" :style="{ background: modo.color }"></div>
            <small style="font-size:11px">{{ modo.etiqueta }}</small>
          </div>
        </div>

      </div>
    </div>

    <!-- Índices CPO -->
    <div class="card mb-3">
      <div class="card-header py-1">
        <small class="fw-bold">Índices CPO / ceo</small>
      </div>
      <div class="card-body py-2">
        <div class="row g-2 text-center">
          <div class="col-6 col-md-3">
            <div class="border rounded p-2">
              <div style="font-size:11px; color:#888">C — Cariados</div>
              <div class="fw-bold fs-5">{{ indiceCpo.cpodCariados }}</div>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="border rounded p-2">
              <div style="font-size:11px; color:#888">P — Perdidos</div>
              <div class="fw-bold fs-5">{{ indiceCpo.cpodPerdidos }}</div>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="border rounded p-2">
              <div style="font-size:11px; color:#888">O — Obturados</div>
              <div class="fw-bold fs-5">{{ indiceCpo.cpodObturados }}</div>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="border rounded p-2 bg-light">
              <div style="font-size:11px; color:#888">CPOD Total</div>
              <div class="fw-bold fs-4 text-primary">
                {{ indiceCpo.cpodCariados + indiceCpo.cpodPerdidos + indiceCpo.cpodObturados }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Panel de detalle -->
    <div class="card mb-3" v-if="piezaSeleccionada">
      <div class="card-header py-1 d-flex align-items-center gap-2">
        <small class="fw-bold">Pieza {{ piezaSeleccionada }}</small>
        <!-- badge de modo -->
        <span v-if="modoVista === 'consultar'" class="badge bg-info text-dark" style="font-size:10px">
          Solo lectura
        </span>
        <span v-else class="badge bg-warning text-dark" style="font-size:10px">
          Editando
        </span>
        <!-- estado actual con color -->
        <span class="ms-auto badge rounded-pill"
          :style="{ background: colorPieza(piezaSeleccionada), color: '#fff', fontSize: '11px' }">
          {{ etiquetaEstado(piezaSeleccionada) }}
        </span>
      </div>
      <div class="card-body py-2">
        <div class="row g-2">
          <div class="col-md-4">
            <label class="form-label" style="font-size:12px">Estado</label>
            <select class="form-select form-select-sm"
              v-model="estadoDientes[piezaSeleccionada]"
              :disabled="!editable || modoVista === 'consultar'"
              @change="calcularCpo">
              <option v-for="modo in modos" :key="modo.valor" :value="modo.valor">
                {{ modo.etiqueta }}
              </option>
            </select>
          </div>
          <div class="col-md-4">
            <label class="form-label" style="font-size:12px">Movilidad (1-3)</label>
            <select class="form-select form-select-sm"
              v-model="detalleDientes[piezaSeleccionada].gradoMovilidad"
              :disabled="!editable || modoVista === 'consultar'">
              <option :value="null">—</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
            </select>
          </div>
          <div class="col-md-4">
            <label class="form-label" style="font-size:12px">Recesión (1-4)</label>
            <select class="form-select form-select-sm"
              v-model="detalleDientes[piezaSeleccionada].gradoRecesion"
              :disabled="!editable || modoVista === 'consultar'">
              <option :value="null">—</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
            </select>
          </div>
          <div class="col-12">
            <label class="form-label" style="font-size:12px">Notas</label>
            <input type="text" class="form-control form-control-sm"
              v-model="detalleDientes[piezaSeleccionada].notas"
              :disabled="!editable || modoVista === 'consultar'"
              maxlength="500">
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import AyudaOdontologia from '@/views/ayuda/AyudaOdontologia.vue'
import api from '@/services/api'
import swal2 from 'sweetalert2'

const DIENTES_SUPERIORES = [18,17,16,15,14,13,12,11,21,22,23,24,25,26,27,28]
const DIENTES_INFERIORES = [48,47,46,45,44,43,42,41,31,32,33,34,35,36,37,38]
const TODOS_DIENTES = [...DIENTES_SUPERIORES, ...DIENTES_INFERIORES]

const MODOS = [
  { valor: 'SANO',                 etiqueta: 'Sano',             color: '#27ae60' },
  { valor: 'CARIES',               etiqueta: 'Caries',           color: '#e74c3c' },
  { valor: 'OBTURADO',             etiqueta: 'Obturado',         color: '#2980b9' },
  { valor: 'EXTRACCION_INDICADA',  etiqueta: 'Extracción ind.',  color: '#c0392b' },
  { valor: 'EXTRAIDO_CARIES',      etiqueta: 'Extraído/caries',  color: '#7f8c8d' },
  { valor: 'EXTRAIDO_OTRA_CAUSA',  etiqueta: 'Extraído/otro',    color: '#95a5a6' },
  { valor: 'ENDODONCIA_INDICADA',  etiqueta: 'Endodoncia ind.',  color: '#e67e22' },
  { valor: 'ENDODONCIA_REALIZADA', etiqueta: 'Endodoncia real.', color: '#1abc9c' },
  { valor: 'SELLANTE_INDICADO',    etiqueta: 'Sellante ind.',    color: '#9b59b6' },
  { valor: 'CORONA',               etiqueta: 'Corona',           color: '#f39c12' },
]

const SIMBOLOS = {
  SANO: '', CARIES: 'C', OBTURADO: 'O',
  EXTRACCION_INDICADA: 'X', EXTRAIDO_CARIES: 'X', EXTRAIDO_OTRA_CAUSA: 'X',
  ENDODONCIA_INDICADA: '▲', ENDODONCIA_REALIZADA: '▲',
  SELLANTE_INDICADO: '*', CORONA: '◇',
}

export default {
  name: 'OdontogramaForm',
  props: {
    p_idAtencion:     { type: Number, required: true },
    p_estadoAtencion: { type: String, default: '' }
  },
  components: { AyudaOdontologia },
  data() {
    const estadoInicial  = Object.fromEntries(TODOS_DIENTES.map(n => [n, 'SANO']))
    const detalleInicial = Object.fromEntries(
      TODOS_DIENTES.map(n => [n, { gradoMovilidad: null, gradoRecesion: null, notas: '' }])
    )
    return {	
      modos: MODOS,
      modoActual: 'SANO',
      modoVista: 'editar',        // 'editar' | 'consultar'
      dientesSuperiores: DIENTES_SUPERIORES,
      dientesInferiores: DIENTES_INFERIORES,
      estadoDientes:  estadoInicial,
      detalleDientes: detalleInicial,
      piezaSeleccionada: null,
      indiceCpo: {
        cpodCariados: 0, cpodPerdidos: 0, cpodObturados: 0,
        ceodCariados: 0, ceodExtraidos: 0, ceodObturados: 0
      },
      guardando: false,
      showModalHelp: false,  
    }
  },
  computed: {
    editable() {
      return this.p_estadoAtencion === 'PENDIENTE' || this.p_estadoAtencion === 'PROCESO'
    }
  },
  mounted() {
    // Si la atención está cerrada, arrancar siempre en consultar
    if (!this.editable) this.modoVista = 'consultar'
    this.cargarOdontograma()
  },
  methods: {
    colorPieza(num) {
      const estado = this.estadoDientes[num] || 'SANO'
      return MODOS.find(m => m.valor === estado)?.color || '#27ae60'
    },
    simboloPieza(num) {
      return SIMBOLOS[this.estadoDientes[num]] || ''
    },
    etiquetaEstado(num) {
      const estado = this.estadoDientes[num] || 'SANO'
      return MODOS.find(m => m.valor === estado)?.etiqueta || estado
    },
    aplicarModo(num) {
      // En modo consultar solo muestra el detalle, nunca modifica
      if (this.modoVista === 'consultar') {
        this.piezaSeleccionada = num
        return
      }
      if (!this.editable) return
      this.estadoDientes[num] = this.modoActual
      this.piezaSeleccionada = num
      this.calcularCpo()
    },
    calcularCpo() {
      let C = 0, P = 0, O = 0
      TODOS_DIENTES.forEach(n => {
        const s = this.estadoDientes[n]
        if (['CARIES', 'ENDODONCIA_INDICADA'].includes(s)) C++
        if (['EXTRAIDO_CARIES', 'EXTRAIDO_OTRA_CAUSA'].includes(s)) P++
        if (['OBTURADO', 'CORONA', 'ENDODONCIA_REALIZADA'].includes(s)) O++
      })
      this.indiceCpo.cpodCariados = C
      this.indiceCpo.cpodPerdidos = P
      this.indiceCpo.cpodObturados = O
    },
    limpiarOdontograma() {
      TODOS_DIENTES.forEach(n => {
        this.estadoDientes[n] = 'SANO'
        this.detalleDientes[n] = { gradoMovilidad: null, gradoRecesion: null, notas: '' }
      })
      this.piezaSeleccionada = null
      this.calcularCpo()
    },
    async cargarOdontograma() {
      try {
        const response = await api.get(`/odontograma/${this.p_idAtencion}`)
        const data = response.data
        if (data.dientes && data.dientes.length > 0) {
          data.dientes.forEach(d => {
            this.estadoDientes[d.numeroPieza] = d.estadoPieza
            this.detalleDientes[d.numeroPieza] = {
              gradoMovilidad: d.gradoMovilidad || null,
              gradoRecesion:  d.gradoRecesion  || null,
              notas:          d.notas          || ''
            }
          })
          this.calcularCpo()
        }
        if (data.indiceCpo) {
          this.indiceCpo = { ...this.indiceCpo, ...data.indiceCpo }
        }
      } catch (error) {
        if (error.response?.status !== 404) {
          console.error('Error al cargar odontograma:', error)
        }
      }
    },
    async guardarOdontograma() {
      this.guardando = true
      try {
        const idUsuario = sessionStorage.getItem('idUsuario') || 1
        const dientes = TODOS_DIENTES.map(num => ({
          numeroPieza:    num,
          estadoPieza:    this.estadoDientes[num],
          color: ['CARIES','EXTRACCION_INDICADA','ENDODONCIA_INDICADA','SELLANTE_INDICADO']
                  .includes(this.estadoDientes[num]) ? 'R' : 'A',
          gradoMovilidad: this.detalleDientes[num].gradoMovilidad,
          gradoRecesion:  this.detalleDientes[num].gradoRecesion,
          notas:          this.detalleDientes[num].notas
        }))
        const payload = {
          idAtencion: this.p_idAtencion,
          dientes,
          indiceCpo: this.indiceCpo
        }
        await api.post(`/odontograma?idUsuario=${idUsuario}`, payload)
        swal2.fire({ title: '¡Éxito!', text: 'Odontograma guardado correctamente.', icon: 'success', confirmButtonText: 'Ok' })
      } catch (error) {
        swal2.fire({ title: 'Error', text: 'No se pudo guardar el odontograma.', icon: 'error', confirmButtonText: 'Ok' })
        console.error(error)
      } finally {
        this.guardando = false
      }
    }
  }
}
</script>

<style src="@/assets/css/listaRegistros.css" scoped></style>
<style src="@/assets/css/especialidades.css"></style>